import React from 'react';

import Header from 'parts/Header';
import Footer from 'parts/Footer';
import HeroContact from 'parts/HeroContact';
import Contact from 'parts/Contact';
import Map from 'parts/Map';

function ContactPage(props) {
    document.title = "Green Hill Resort | Kontak Kami";
    window.scrollTo(0, 0);

    return (
        <>
            <Header {...props} />
            <HeroContact />
            <Contact />
            <Map />
            <Footer />
        </>
    );
}

export default ContactPage;